import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  InputNumber,
  notification,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  goalKPIFinance,
} from 'api/Project/kpifinance'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  const {
    idEditPRJ,
    visableModalMinMax,
    setVisableModalMinMax,
    data,
    getResultKpi,
    idtask,
    type,
    typeState,
  } = props

  const language = getCookie('lang')
  const word = lang[language]

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [estimiteMin, setEstimiteMin] = useState(0)
  const [estimiteMax, setEstimiteMax] = useState(0)

  // const [visableModal, setVisableModal] = useState(false)
  const [form] = Form.useForm()

  const openNotificationWithIcon = (type, data) => {
    notification[type]({
      message: 'Success',
      description: 'You have been updated.',
      duration: 3,
    })
  }
  const handleClearValue = () => {
    setVisableModalMinMax(false)
    const dataArray = {
      projectkpi_id: data.id,
      project_id: parseInt(idEditPRJ),
      sprintflow_id: idtask,
      input_type_id: data.input_type_id,
      min: 0,
      max: 0,
    }
    goalKPIFinance({
      token: token,
      params: dataArray,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (status == 200) {
          openNotificationWithIcon('success', data)
          form.setFieldsValue({
            min: null,
            max: null,
          })
          getResultKpi()
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const onFinishMinMax = (values) => {
    setVisableModalMinMax(false)
    const dataArray = {
      projectkpi_id: data.id,
      project_id: parseInt(idEditPRJ),
      sprintflow_id: idtask,
      input_type_id: data.input_type_id,
      min: values.min,
      max: values.max,
    }
    goalKPIFinance({
      token: token,
      params: dataArray,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (status == 200) {
          openNotificationWithIcon('success', data)
          form.setFieldsValue({
            min: null,
            max: null,
          })
          getResultKpi()
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const [minInput, setMinInput] = useState('')
  const [maxInput, setMaxInput] = useState('')
  const [minDefault, setMinDefault] = useState('')
  const [maxDefault, setMaxDefault] = useState('')

  useEffect(() => {
    if (data) {
      if (typeState == 'project') {
        if (data.sprintflow_min == 0 && data.sprintflow_max == 0) {
          form.setFieldsValue({
            min: 0,
            max: 0,
          })
          setMinInput(0)
          setMaxInput(0)
          setEstimiteMin(0)
          setEstimiteMax(0)
        } else {
          form.setFieldsValue({
            min: data.sprintflow_min,
            max: data.sprintflow_max,
          })
          setMinInput(data.sprintflow_min)
          setMaxInput(data.sprintflow_max)
          setEstimiteMin(data.sprintflow_min)
          setEstimiteMax(data.sprintflow_max)
        }
        setMinDefault(data.sprintflow_parent_min)
        setMaxDefault(data.sprintflow_parent_max)

        form.setFieldsValue({
          remin: data.sprintflow_parent_min,
          remax: data.sprintflow_parent_max,
        })
      } else {
        if (data.sprintflow_min == 0 && data.sprintflow_max == 0) {
          form.setFieldsValue({
            min: 0,
            max: 0,
          })
          setMinInput(0)
          setMaxInput(0)
          setEstimiteMin(0)
          setEstimiteMax(0)
        } else {
          form.setFieldsValue({
            min: data.sprintflow_min,
            max: data.sprintflow_max,
          })
          setMinInput(data.sprintflow_min)
          setMaxInput(data.sprintflow_max)
          setEstimiteMin(data.sprintflow_min)
          setEstimiteMax(data.sprintflow_max)
        }
        setMinDefault(data.min)
        setMaxDefault(data.max)
        form.setFieldsValue({
          remin: data.min,
          remax: data.max,
        })
      }
    }
    SuccessMax()
    SuccessMin()
  }, [visableModalMinMax])

  const [disableBtnMin, setDisableBtnMin] = useState(false)
  const [disableBtnMax, setDisableBtnMax] = useState(false)
  const [displayErrorMin, setDisplayErrorMin] = useState()
  const [displayErrorMax, setDisplayErrorMax] = useState()
  const [errorWordMax, setErrorWordMax] = useState()
  const [errorWordMin, setErrorWordMin] = useState()
  const [styleErrorMax, setStyleErrorMax] = useState()
  const [styleErrorMin, setStyleErrorMin] = useState()

  function ErrorMin() {
    setDisplayErrorMin('')
    setDisableBtnMin(true)
    setStyleErrorMin(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-error',
    )
  }

  function SuccessMin() {
    setDisplayErrorMin('none')
    setDisableBtnMin(false)
    setStyleErrorMin(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
    )
  }

  function ErrorMax() {
    setDisplayErrorMax('')
    setDisableBtnMax(true)
    setStyleErrorMax(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-error',
    )
  }

  function SuccessMax() {
    setDisplayErrorMax('none')
    setDisableBtnMax(false)
    setStyleErrorMax(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
    )
  }

  // const ReCheckMin = (value) => {
  //   // let split = `${minInput}`.split('.')
  //   // if (split[1]) {
  //   //   if (split[1].length > 2) {
  //   //     ErrorMin()
  //   //     setErrorWordMin(word['addtask_kpi_alert_modaltaskminmax_validmin'])
  //   //   } else if (minInput < minDefault) {
  //   //     ErrorMin()
  //   //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (minInput > maxDefault) {
  //   //     ErrorMin()
  //   //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (minInput > value) {
  //   //     ErrorMin()
  //   //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (minInput <= value) {
  //   //     SuccessMax()
  //   //     SuccessMin()
  //   //   } else {
  //   //     SuccessMin()
  //   //   }
  //   // } else
  //   if (minInput < minDefault) {
  //     ErrorMin()
  //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (minInput > maxDefault) {
  //     ErrorMin()
  //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (minInput > value) {
  //     ErrorMin()
  //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (minInput <= value) {
  //     SuccessMax()
  //     SuccessMin()
  //   } else {
  //     SuccessMin()
  //   }
  // }
  // const ReCheckMax = (value) => {
  //   // let split = `${maxInput}`.split('.')
  //   // if (split[1]) {
  //   //   if (split[1].length > 2) {
  //   //     ErrorMax()
  //   //     setErrorWordMax(word['addtask_kpi_alert_modaltaskminmax_validmax'])
  //   //   } else if (maxInput > maxDefault) {
  //   //     ErrorMax()
  //   //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (maxInput < minDefault) {
  //   //     ErrorMax()
  //   //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (maxInput < value) {
  //   //     ErrorMax()
  //   //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   //   } else if (maxInput >= value) {
  //   //     SuccessMin()
  //   //     SuccessMax()
  //   //   } else {
  //   //     SuccessMax()
  //   //   }
  //   // } else
  //   if (maxInput > maxDefault) {
  //     ErrorMax()
  //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (maxInput < minDefault) {
  //     ErrorMax()
  //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (maxInput < value) {
  //     ErrorMax()
  //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //   } else if (maxInput >= value) {
  //     SuccessMin()
  //     SuccessMax()
  //   } else {
  //     SuccessMax()
  //   }
  // }

  const [checkInOnchange, setCheckInOnChange] = useState(0)
  // const onChangeMin = (value) => {
  //   setCheckInOnChange(checkInOnchange + 1)
  //   setMinInput(value)

  //   if (value == '') {
  //     setEstimiteMin(0)
  //   } else if (typeof value !== 'string') {
  //     setEstimiteMin(value)
  //   }

  //   if (typeof value == 'string') {
  //     ErrorMin()
  //     setErrorWordMin(word['addtask_kpi_alert_modaltaskminmax_validmin'])
  //   } else {
  //     // let split = `${value}`.split('.')
  //     // if (split[1]) {
  //     //   if (split[1].length > 2) {
  //     //     ErrorMin()
  //     //     setErrorWordMin(word['addtask_kpi_alert_modaltaskminmax_validmin'])
  //     //   } else if (value < minDefault) {
  //     //     ErrorMin()
  //     //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value > maxDefault) {
  //     //     ErrorMin()
  //     //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value > maxInput) {
  //     //     ErrorMin()
  //     //     setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value <= maxInput) {
  //     //     SuccessMin()
  //     //     ReCheckMax(value)
  //     //   } else {
  //     //     SuccessMin()
  //     //   }
  //     // } else

  //     // check min task goals between goals */
  //     if (value < minDefault) {
  //       ErrorMin()
  //       setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value > maxDefault) {
  //       ErrorMin()
  //       setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value > maxInput) {
  //       ErrorMin()
  //       setErrorWordMin(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value <= maxInput) {
  //       SuccessMin()
  //       ReCheckMax(value)
  //     } else {
  //       SuccessMin()
  //     }
  //   }
  // }

  // const onChangeMax = (value) => {
  //   let split = `${value}`.split('.')
  //   setMaxInput(value)
  //   setCheckInOnChange(checkInOnchange + 1)

  //   if (value == '') {
  //     setEstimiteMax(0)
  //   } else if (typeof value !== 'string') {
  //     setEstimiteMax(value)
  //   }

  //   if (typeof value == 'string') {
  //     ErrorMax()
  //     setErrorWordMax(word['addtask_kpi_alert_modaltaskminmax_validmax'])
  //   } else {
  //     // if (split[1]) {
  //     //   if (split[1].length > 2) {
  //     //     ErrorMax()
  //     //     setErrorWordMax(word['addtask_kpi_alert_modaltaskminmax_validmax'])
  //     //   } else if (value > maxDefault) {
  //     //     ErrorMax()
  //     //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value < minDefault) {
  //     //     ErrorMax()
  //     //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value < minInput) {
  //     //     ErrorMax()
  //     //     setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     //   } else if (value >= minInput) {
  //     //     ReCheckMin(value)
  //     //     SuccessMax()
  //     //   } else {
  //     //     SuccessMax()
  //     //   }
  //     // } else

  //     // check max task goals between goals */
  //     if (value > maxDefault) {
  //       ErrorMax()
  //       setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value < minDefault) {
  //       ErrorMax()
  //       setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value < minInput) {
  //       ErrorMax()
  //       setErrorWordMax(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
  //     } else if (value >= minInput) {
  //       ReCheckMin(value)
  //       SuccessMax()
  //     } else {
  //       SuccessMax()
  //     }
  //   }
  // }

  const onChangeMinV2 = (value) => {
    setCheckInOnChange(checkInOnchange + 1);
    setMinInput(value);

    const isString = typeof value === 'string';

    if (value === '') {
      setEstimiteMin(0);
    } else if (!isString) {
      setEstimiteMin(value);
    }

    if (isString) {
      ErrorMin();
      setErrorWordMin(word['addtask_kpi_alert_modaltaskminmax_validmin']);
    } else {
      if (value > maxInput) {
        ErrorMin();
        setErrorWordMin(word['addtask_kpi_alert_modaltaskminmax_validmin']);
      } else {
        SuccessMin();
        if (value <= maxInput) {
          ReCheckValueInput(value, 'max');
        }
      }
    }
  };

  const onChangeMaxV2 = (value) => {

    setMaxInput(value)
    setCheckInOnChange(checkInOnchange + 1)

    const isString = typeof value === 'string';

    if (value == '') {
      setEstimiteMax(0)
    } else if (!isString) {
      setEstimiteMax(value)
    }

    if (isString) {
      ErrorMax()
      setErrorWordMax(word['addtask_kpi_alert_modaltaskminmax_validmax'])
    } else {
      if (value < minInput) {
        ErrorMax();
        setErrorWordMax(word['addtask_kpi_alert_modaltaskminmax_validmax']);
      } else {
        SuccessMax();
        if (value >= minInput) {
          ReCheckValueInput(value, 'min');
        }
      }
    }
  }

  const ReCheckValueInput = (value, type) => {
    let input, errorFunction, successFunction, errorWordFunction, errorWord;

    if (type === 'min') {
      input = minInput;
      errorFunction = ErrorMin;
      successFunction = SuccessMin;
      errorWordFunction = setErrorWordMin;
      errorWord = word['addtask_kpi_alert_modaltaskgoal_goalsbetween'];
    } else if (type === 'max') {
      input = maxInput;
      errorFunction = ErrorMax;
      successFunction = SuccessMax;
      errorWordFunction = setErrorWordMax;
      errorWord = word['addtask_kpi_alert_modaltaskgoal_goalsbetween'];
    } else {
      return;
    }

    if ((type === 'min' && input > value) || (type === 'max' && input < value)) {
      errorFunction();
      errorWordFunction(errorWord);
    } else {
      successFunction();
      if ((type === 'min' && input <= value) || (type === 'max' && input >= value)) {
        if (type === 'min') SuccessMax();
        else SuccessMin();
      }
    }
  };

  const [realDisable, setRealDisable] = useState(false)

  const checkDisableBtn = (btnMin, btnMax) => {
    if (minInput == 0 && maxInput == 0) {
      setRealDisable(false)
    } else {
      if (btnMin == true || btnMax == true) {
        setRealDisable(true)
      } else {
        setRealDisable(false)
      }
    }
  }

  useEffect(() => {
    checkDisableBtn(disableBtnMin, disableBtnMax)
  }, [checkInOnchange])

  const onClose = () => {
    setVisableModalMinMax(false)
    setRealDisable(false)
    setMinInput('')
    setMaxInput('')
    setCheckInOnChange(0)
    setDisableBtnMin(false)
    setDisableBtnMax(false)
    setDisplayErrorMin('none')
    setDisplayErrorMax('none')
    setErrorWordMax()
    setErrorWordMin()
    setStyleErrorMax()
    setStyleErrorMin()
  }
  return (
    <Modal
      maskClosable={false}
      title={<h2 className="Modaltitle">{data.name}</h2>}
      visible={visableModalMinMax}
      // okButtonProps={{ disabled: realDisable }}
      // onOk={form.submit}
      onCancel={() => onClose()}
      okText="Update"
      className="editmodal edit-width disable-page dispalynoneupdowninputnumber"
      footer={null}
    >
      <Form form={form} onFinish={onFinishMinMax}>
        <h4 style={{ marginBottom: 8 }}>
          {type} {word['addtask_kpi_title_modaltaskminmax_taskminmax']}{' '}
          {data.unit_type_name} (Between{' '}
          {typeState == 'project'
            ? data.sprintflow_parent_min
              ? data.sprintflow_parent_min.toFixed(2)
              : 0
            : data.min
              ? data.min.toFixed(2)
              : 0}{' '}
          -{' '}
          {typeState == 'project'
            ? data.sprintflow_parent_max
              ? data.sprintflow_parent_max.toFixed(2)
              : 0
            : data.max
              ? data.max.toFixed(2)
              : 0}
          )
        </h4>
        <Row>
          <Col span={12} style={{ paddingRight: 4 }}>
            <Form.Item
              name="min"
              className={styleErrorMin}
              rules={[
                {
                  pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                  message: word['Project_KPI/Finance_GoalMax'],
                },
              ]}
              extra="Please enter your goals between goals"
            >
              <InputNumber
                type="number"
                onChange={onChangeMinV2}
                className="border"
                placeholder="Min"
                size="large"
                // maxLength={12}
                max={9999999999999999.99}
                style={{ width: '100%' }}
                step="0.00"
              ></InputNumber>
            </Form.Item>
            <div style={{ height: 50 }}>
              <div
                style={{ display: displayErrorMin }}
                class="ant-form-item-explain ant-form-item-explain-info"
              >
                <div role="alert">{errorWordMin}</div>
              </div>
            </div>
          </Col>

          <Col span={12} style={{ paddingLeft: 4 }}>
            <Form.Item
              className={styleErrorMax}
              name="max"
              rules={[
                {
                  pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                  message: word['Project_KPI/Finance_GoalMax'],
                },
              ]}
              extra="Please enter your goals between goals"
            >
              <InputNumber
                type="number"
                onChange={onChangeMaxV2}
                className="border"
                placeholder="Max"
                size="large"
                style={{ width: '100%' }}
                // maxLength={12}
                max={9999999999999999.99}
                step="0.00"
              ></InputNumber>
            </Form.Item>

            <div style={{ height: 50 }}>
              <div
                style={{ display: displayErrorMax }}
                className={'ant-form-item-explain ant-form-item-explain-info'}
              >
                <div role="alert">{errorWordMax}</div>
              </div>
            </div>
          </Col>
        </Row>
        <Col span={24}>
          <Row style={{ marginTop: -25 }}>
            <h4>Estimate ≈ </h4>
            <h4 style={{ marginLeft: 5, color: '#7C7C84' }}>
              {estimiteMin ? estimiteMin.toFixed(2) : 0}{' '}
            </h4>
            <h4 style={{ marginLeft: 5, marginRight: 5 }}>-</h4>{' '}
            <h4 style={{ color: '#7C7C84' }}>
              {' '}
              {estimiteMax ? estimiteMax.toFixed(2) : 0}{' '}
            </h4>
          </Row>
        </Col>

        {/* <div style={{ marginTop: 24 }}>
          <h4 style={{ marginBottom: 8 }}>Remaining</h4>
          <Row>
            <Col span={12} style={{ paddingRight: 4 }}>
              <Form.Item name="remin">
                <InputNumber
                  disabled
                  // className="border"
                  size="large"
                  style={{ width: '100%' }}
                  step="0.00"
                ></InputNumber>
              </Form.Item>
            </Col>

            <Col span={12} style={{ paddingLeft: 4 }}>
              <Form.Item name="remax">
                <InputNumber
                  disabled
                  // className="border"
                  size="large"
                  style={{ width: '100%' }}
                  step="0.00"
                ></InputNumber>
              </Form.Item>
            </Col>
          </Row>
        </div> */}

        <div style={{ marginTop: 12, justifyContent: 'flex-end', display: 'flex' }}>
          <Button className="BTN_Warning" onClick={handleClearValue}>
            {word['addtask_kpi_title_modaltaskgoal_cancelvalue']}
          </Button>
          <Button
            className="BTN_Next"
            style={{ marginLeft: 8 }}
            onClick={form.submit}
            disabled={realDisable}
          >
            {word['addtask_kpi_title_modaltaskgoal_update']}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}
export default AddTaskKPIFinance
